<template>
  <div style="padding-bottom: 30px">
    <user-info :detail="userDetail" />

    <el-card class="mt16">
      <template #header>
        <h4>{{ $t('体重计划') }}</h4>
      </template>
      <el-descriptions>
        <el-descriptions-item :label="$t('体重')">{{ userDetail.weight || "" }}</el-descriptions-item>
        <el-descriptions-item :label="$t('身高')">{{ userDetail.high || "" }}</el-descriptions-item>
        <el-descriptions-item :label="$t('目标体重')">{{ userDetail.targetWeight || "" }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <data-stats class="mt16" />

    <user-records class="mt16" />

    <user-recipe-tab class="mt16" />

    <recipe-record-tab class="mt16" />

    <user-deal class="mt16" />

    <user-other-tab class="mt16" />

  </div>
</template>

<script>
import UserInfo from "@/components/user/UserInfo";
import DataStats from "@/components/user/DataStats";
import UserRecords from "@/components/user/UserRecords";
import UserRecipeTab from "@/components/user/UserRecipeTab";
import RecipeRecordTab from "@/components/user/RecipeRecordTab";
import UserDeal from "@/components/user/UserDeal";
import UserOtherTab from "@/components/user/UserOtherTab";
import {request} from "@/config/request";
export default {
  name: "UserDetail",
  components: {UserOtherTab, UserDeal, RecipeRecordTab, UserRecipeTab, UserRecords, DataStats, UserInfo},
  data() {
    return {
      userDetail: {}
    }
  },
  methods: {
    // 详情
    async handleLoadDetail() {
      try {
        let res = await request(this.$api.anUser.detail, this.$route.query);
        this.userDetail = res.anUser;
        this.$store.commit("USER_DETAIL", this.userDetail);
      }catch(e) {
        console.log(e);
      }
    },
  },
  created() {
    this.handleLoadDetail();
  }
}
</script>

<style scoped>

</style>
